(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EventItemListController', EventItemListController);

    EventItemListController.$inject = ['$scope', '$state', '$stateParams', '$location', 'ServiceItem', 'ServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceItemCustom', '$translate', '$mdDialog'];

    function EventItemListController($scope, $state, $stateParams, $location, ServiceItem, ServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServiceItemCustom, translate, $mdDialog) {
        var vm = this;
        //

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pageSize = 3;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;
        vm.categoryName = categoryName;
        vm.copyServiceItem = copyServiceItem;
        vm.goToVideoCallEvent = goToVideoCallEvent;

        loadAll();
        loadPage();

        function loadAll() {
            //
            //if (pagingParams.search) {
            //    ServiceItemSearch.query({
            //
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceItem.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}


            //

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage() {
            vm.serviceItems = ServiceItemCustom.getServiceItemsByCurrentCompany().query();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusStyle(serviceStatus) {
            return "service-item-status-" + serviceStatus;
        }

        function findStatusIcon(serviceStatus) {
            if (serviceStatus == "DISABLE") {
                return "glyphicon glyphicon-ban-circle";
            }
            if (serviceStatus == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (serviceStatus == "PUBLISH_JUST_PANEL") {
                return "glyphicon glyphicon-lock";
            }
            if (serviceStatus == "RESERVE_JUST_PANEL") {
                return "glyphicon glyphicon-eye-open";
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function copyServiceItem(serviceItemId) {
            ServiceItemCustom.createCopyOfServiceItemById(serviceItemId).query(function (res) {
                vm.loadPage();
            });
        }

        function goToVideoCallEvent(serviceItem) {
            var servant = {};

            if (serviceItem.servants.length > 0)
                servant = serviceItem.servants[0];

            $mdDialog.show({
                controller: 'JoinVideoMeetingEventComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting-event/partial-form.join-video-meeting-event.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            serviceItem: serviceItem,
                            servant: servant

                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }

    }
})();
